export const OFFSET_MULTIPLIER = 20;
export const PAGE_NORMALIZER = 1;
export const DEFAULT_OFFSET = 0;
export const DEFAULT_ROWS = DEFAULT_OFFSET;

export const queryOptions = {
  arrayFormat: 'comma',
  skipNull: true,
  skipEmptyString: true,
};
